import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { CONTACT } from "@/constants/config";
import { useLang } from "@/constants/i18n";
import { scrollToSection } from "@/lib/scroll";

export const MobileCta = () => {
    const { t } = useLang();
    return (
        <div
            data-testid="mobile-cta-bar"
            className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-3 border-t border-gold/30 bg-burgundy/95 backdrop-blur-xl md:hidden"
        >
            <a
                href={CONTACT.phoneHref}
                data-testid="mobile-cta-call"
                className="flex flex-col items-center gap-1 py-3 text-ivory transition-colors duration-300 active:bg-burgundy-deep"
            >
                <Phone className="h-5 w-5 text-gold" />
                <span className="text-[10px] uppercase tracking-[0.2em]">{t.mobileCta.call}</span>
            </a>
            <a
                href={CONTACT.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-cta-whatsapp"
                className="flex flex-col items-center gap-1 border-x border-gold/20 py-3 text-ivory transition-colors duration-300 active:bg-burgundy-deep"
            >
                <MessageCircle className="h-5 w-5 text-gold" />
                <span className="text-[10px] uppercase tracking-[0.2em]">{t.mobileCta.whatsapp}</span>
            </a>
            <button
                onClick={() => scrollToSection("#contacto")}
                data-testid="mobile-cta-book"
                className="flex flex-col items-center gap-1 py-3 text-ivory transition-colors duration-300 active:bg-burgundy-deep"
            >
                <CalendarCheck className="h-5 w-5 text-gold" />
                <span className="text-[10px] uppercase tracking-[0.2em]">{t.mobileCta.book}</span>
            </button>
        </div>
    );
};

export default MobileCta;
